import { Pagination, Period } from './shared'

import { Float } from '../../foundation'

export interface RequestGetDailyServiceOfferPerformancesData {
  pagination: Pagination

  filter: {
    serviceOfferIds: number[]
    period: Period
  }
}

export interface DailyServiceOfferPerformance {
  id: 0
  targetDate: string
  serviceOfferId: number
  serviceOfferTitle: string | null
  serviceOfferCountry: 'KR' | 'JP'
  hospitalId: number
  hospitalName: string
  pageViewCount: number
  consultationCount: number
  purchaseCount: number
  conversionCount: number
  conversionRate: Float
  unitCpvCost: number
  totalCpvCost: number
  costPerConversion: Float | null
}

export interface RequestGetServiceOfferPerformanceSummaryData {
  filter: {
    serviceOfferId: number | null
    period: Period
  }
}

export enum RevenueModel {
  'CPV' = 'CPV',
  'CPA' = 'CPA',
  'DYNAMIC_CPV' = 'DYNAMIC_CPV',
}

export interface ServiceOfferPerformanceSummary {
  hospitalId: number
  pageViewCount: number
  conversionCount: number
  conversionRate: Float
  unitCpvCost: Float
  totalCpvCost: number
  costPerConversion: Float
}
